import * as React from 'react'

export const VIEWPORT_MARGIN = 16
export const GAP = 4
export const DEFAULT_CALENDAR_HEIGHT = 320

export const getCalendarPositionStyles = (input: HTMLElement, calendarHeight: number): React.CSSProperties => {
  const rect = input.getBoundingClientRect()
  const spaceBelow = window.innerHeight - rect.bottom - VIEWPORT_MARGIN
  const spaceAbove = rect.top - VIEWPORT_MARGIN
  const openBelow = spaceBelow >= calendarHeight + GAP || spaceBelow >= spaceAbove

  return {
    position: 'fixed',
    zIndex: 1300,
    right: `${window.innerWidth - rect.right}px`,
    width: 'fit-content',
    ...(openBelow ? { top: `${rect.bottom + GAP}px` } : { bottom: `${window.innerHeight - rect.top + GAP}px` }),
  }
}
